module.exports = __webpack_public_path__ + "b56b8e213.jpg";